/**
 * React Query hook for users who liked the current user
 */

import { useQuery } from "@tanstack/react-query";
import { discoveryService } from "../services/discoveryService";

export const likedYouQueryKeys = {
  all: ["liked-you"] as const,
  list: (userId: string) => [...likedYouQueryKeys.all, userId] as const,
};

export function useLikedYouUsers(currentUserId: string) {
  return useQuery({
    queryKey: likedYouQueryKeys.list(currentUserId),
    queryFn: () => discoveryService.getLikedYouUsers(currentUserId),
    staleTime: 5 * 60 * 1000,
    enabled: !!currentUserId,
  });
}
